import { Vue, Component, Prop } from 'vue-property-decorator'
import { VDataTable, VRow, VSelect, VSkeletonLoader, VSpacer, VPagination, VLayout } from 'vuetify/lib'

import './DataTable.scss'
import { VCol } from 'vuetify/lib/components'

/**
 * Este componente é uma extensão do Vuetify Datatable
 */
export const AppDataTable = Vue.component('AppDataTable', {
	name: 'AppDataTable',
	//extends: VDataTable,
	props: {
		query: { type: Object, default: { page: 1 } },
		loading: { type: Boolean, default: true },
		oldPagination: { type: Boolean, default: true },
		hideDefaultFooter: { type: Boolean, default: true },
		page: { type: Number, default: null },
		tableRef: { type: String, default: '' },
		totalItems: { type: Number, default: null }
	},

	data: () => ({
		currentPage: 1
	}),

	computed: {
		resultSize() {
			if (this.oldPagination) return this.$attrs?.items?.length
			return this.totalItems ?? 0
		},

		canNext() {
			if (this.oldPagination) return this.$attrs?.items?.length == this.searchParams.itemsPerPage ? 300 : 0

			return this.items?.length == this.searchParams.itemsPerPage ? 300 : 0
		},

		searchParams() {
			return this.query
		},

		paginationLength() {
			let result = Math.ceil(this.resultSize / this.searchParams.itemsPerPage)
			if (!result || result <= 0) result = 1

			return result
		}
	},

	beforeMount() {
		this.currentPage = this.page ? this.page : this.searchParams.page
	},

	methods: {
		renderTableFooterItems() {
			if (this.$scopedSlots['table:footer']) return this.$scopedSlots['table:footer'](this.$props)
		},

		renderPagination() {
			if (this.oldPagination) return this.renderOldPagination()

			return this.renderNewPagination()
		},

		renderNewPagination() {
			return (
				<div class="pt-4">
					{this.renderTableFooterItems()}

					<VRow align="center" class="new-pagination d-flex align-center">
						<VCol cols="12" sm="12" class="pb-0">
							<VPagination
								vModel={this.currentPage}
								total-visible="8"
								circle
								length={this.paginationLength}
								on={{
									input: () => this.$emit('update:page', { ref: this.tableRef, page: this.currentPage })
								}}
							/>
						</VCol>
					</VRow>
				</div>
			)
		},

		renderOldPagination() {
			return (
				<div class="px-4 py-8">
					<VRow align="center" class="ml-4">
						{this.renderTableFooterItems()}
						<VSpacer />

						<VSelect
							data-cy="btn-itens-pagina"
							hide-details
							outlined
							dense
							label="Itens por página"
							style="max-width: 128px"
							items={[20, 50, 75, 100]}
							vModel={this.searchParams.itemsPerPage}
							class="mr-4 items-per-page-bg"
							loading={this.loading}
						/>

						<VSkeletonLoader type="list-item" class={{ 'px-8': this.loading }} loading={this.loading}>
							<div class="caption px-6">
								{1 + this.searchParams.itemsPerPage * (this.searchParams.page - 1)}-
								{this.searchParams.itemsPerPage * (this.searchParams.page - 1) + this.resultSize} itens
							</div>
						</VSkeletonLoader>

						<VPagination elevation="0" vModel={this.searchParams.page} total-visible="0" length={this.canNext} />
					</VRow>
				</div>
			)
		}
	},

	render() {
		return (
			<VLayout no-gutters column>
				<VDataTable
					class="atta-datatable-table"
					dense
					locale="pt-br"
					{...{ attrs: this.$attrs, props: this.$props }}
					onUpdateMode={(val: string) => {}}
					sortBy={this.query.sortBy}
					sortDesc={this.query.sortDesc}
					on={{
						'update:options': (options: any) => this.$emit('update:options', options)
					}}
					scopedSlots={this.$scopedSlots}
				/>

				<div class="atta-datatable-footer">{this.renderPagination()}</div>
			</VLayout>
		)
	}
})

export default AppDataTable
